module.exports = __webpack_public_path__ + "img/262.b1024b48.png";